import Vue from 'vue'
import moment from 'moment'
Vue.filter('toYearMonth', function (value) {
    if (value) {
        return moment(value).format('YYYY-MM')
    }
})
Vue.filter('toDay', function (value) {
    if (value) {
        return moment(value).format('DD')
    }
})
Vue.filter('toArray', function (str) {
    if (str) {
        return str.split(',')
    } else {
        return []
    }
})
Vue.filter('toDate', function (value) {
    if (value) {
        return moment(value).format('YYYY-MM-DD')
    }
})
Vue.filter('toSrc', function (value) {
    if (value) {
        // eslint-disable-next-line no-undef
        return config.ip + value
    }
})
